import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface BackgroundGradientProps {
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
  animate?: boolean;
}

export function BackgroundGradient({
  children,
  className,
  containerClassName,
  animate = true,
}: BackgroundGradientProps) {
  return (
    <div className={cn('relative p-[2px] rounded-full', containerClassName)}>
      {animate ? (
        <motion.div
          className="absolute inset-0 rounded-full"
          style={{
            background: 'conic-gradient(from 0deg, #000000, #0000FF, #FFFFFF, #000000)',
          }}
          animate={{
            rotate: 360,
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'linear',
          }}
        />
      ) : (
        <div className="absolute inset-0 rounded-full bg-gradient-to-r from-black via-[#0000FF] to-white" />
      )}
      {/* Static glowing drop shadow */}
      <div
        className="absolute inset-0 rounded-full blur-xl -z-10"
        style={{
          background: 'conic-gradient(from 0deg, #000000, #0000FF, #FFFFFF, #000000)',
          transform: 'translateY(4px) scale(0.95)',
          opacity: 0.6,
        }}
      />
      <div className={cn('relative rounded-full bg-white', className)}>{children}</div>
    </div>
  );
}
